import React, { useEffect, useState } from "react";
import classNames from "classnames";
import Portal from "../Portal";
import { Fade } from "../Transitions";
import { ZoomIn } from "../Transitions";
import Button from "../Button";
import { getOtherProperties, setValueToNumber } from "../common/Utils";
import { ModalProps } from "./PropsType";

export default function Modal(props: ModalProps) {
  const {
    className,
    children,
    header,
    maxHeight,
    prefixCls = "bm-Modal",
    ...other
  }: any = props;
  const styleClass = classNames(
    prefixCls,
    {
      [`${prefixCls}-max`]: maxHeight,
    },
    className
  );
  const panelClass = classNames(`${prefixCls}-panel`, {
    "bm-Scroll": maxHeight,
  });
  const panelStyles = {
    maxHeight: setValueToNumber(maxHeight) + "px",
  };
  const otherProps = getOtherProperties(other, [
    "hideBackdrop",
    "onClose",
    "onOpen",
  ]);

  const [visible, setVisible] = useState(!!props.visible);

  const handleClose = () => {
    (props.onClose as () => void)();
  };

  const handleBackdropClick = () => {
    if (props.hideBackdrop) {
      (props.onClose as () => void)();
    }
  };

  useEffect(() => {
    setVisible(!!props.visible);
  }, [props.visible]);

  return (
    <Portal mountNode={document.body} visible={visible}>
      <div className={styleClass}>
        <Fade in={visible}>
          <div
            className={`${prefixCls}-backdrop`}
            onClick={handleBackdropClick}
          />
        </Fade>
        <ZoomIn in={visible}>
          <div className={`${prefixCls}-content`} {...otherProps} key="Modal">
            {header ? (
              <div className={`${prefixCls}-header`}>
                {header}
                <Button
                  className={`${prefixCls}-close-x`}
                  onClick={handleClose}
                >
                  <svg
                    className="icon bm-icon-close"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="838"
                    width="64"
                    height="64"
                  >
                    <path
                      d="M572.16 512l183.466667-183.04a42.666667 42.666667 0 1 0-60.586667-60.586667L512 451.84l-183.04-183.466667a42.666667 42.666667 0 0 0-60.586667 60.586667l183.466667 183.04-183.466667 183.04a42.666667 42.666667 0 0 0 0 60.586667 42.666667 42.666667 0 0 0 60.586667 0l183.04-183.466667 183.04 183.466667a42.666667 42.666667 0 0 0 60.586667 0 42.666667 42.666667 0 0 0 0-60.586667z"
                      p-id="839"
                    ></path>
                  </svg>
                </Button>
              </div>
            ) : null}
            <div className={panelClass} style={maxHeight ? panelStyles : {}}>
              {children}
            </div>
          </div>
        </ZoomIn>
      </div>
    </Portal>
  );
}
